//import Vue from 'vue'
//import VueRouter from 'vue-router'
import { createRouter, createWebHistory } from "vue-router";

//Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'principal',
    // component: Dashboard
    //component: () => import('../views/Dashboard.vue')
    //component: () => import('@/Principal.vue')
    //component: () => import('../views/promociones/Promocionmf.vue')
    //component: () => import('../views/formularionegociacion/Formulario.vue')
    component: () => import('../views/formularionegociacion/HistoriaClinica.vue')
  },
  {
    path: '/persona',
    name: 'persona',
    component: () => import('../views/formularionegociacion/Persona.vue')
  },
  {
    path: '/historiaclinica',
    name: 'historiaclinica',
    component: () => import('../views/formularionegociacion/HistoriaClinica.vue')
  },
  {
    path: '/users',
    name: 'historusersiaclinica',
    component: () => import('../views/formularionegociacion/Usuario.vue')
  },
  {
    path: '/cerrarsession',
    name: 'About',
    component: () => import('../views/login/CerrarSession.vue')
  },
  {
    path: '/empleados',
    name: 'mensaje',
    component: () => import('../views/formularionegociacion/Empleados.vue')
  },
  {
    path: '/promocion',
    name: 'promocion',
    component: () => import('../views/promociones/Promocionmf.vue')
  },
  {
    path: '/saldosCliente',
    name: 'saldosCliente',
    component: () => import('../views/promociones/Verpromocion.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login.vue')
  },
  {
    path:'/:pathMatch(.*)',
    component:() => import('../components/NotFound.vue')
  }
  ,
  {
    path: '/epromo',
    name: 'epromo',
    component:() => import('../views/promociones/Promocion.vue')
  }
]

/*
const router = new VueRouter({
  routes
})
*/
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,  
  
});


export default router
